import DashboardFieldList from './DashboardFieldList'
import AddField from './AddField'
import './DashboardFieldEditor.scoped.scss'

export default function DashboardFieldEditor() {
  const orderedDashboardFields = useSel(s => 
    _.orderBy(
      _.values(s.dashboardFields.entities).filter(f => f.active), 
      ['digitOrder'], 
      ['asc']
    )
  )
  
  return (
    <div>
      <div className="column-headers margin-bottom">
        {orderedDashboardFields.map((field, index) => (
          <div key={field.id} className="column-header">
            {field.name}
          </div>
        ))}
      </div>

      <DashboardFieldList />
      <AddField />
    </div>
  )
}
